module.exports = __webpack_public_path__ + "static/img/lab-sample.6953c7e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20250724/ruanjian/lab-sample.svg
// module id = pZMD
// module chunks = 24